import { useCallback, type FC } from 'react'

import { useUpdateUserCarouselsMutation } from 'api/userCarousels/mutations'
import { updateUserCarouselsQueryClient } from 'api/userCarousels/setters'
import { UserCarouselSlug } from 'api/userCarousels/types'
import { UserCarousel } from 'components/UserCarousel'

type Props = {
  carouselSlug: UserCarouselSlug
}

export const AutoTriggeredUserCarousel: FC<Props> = ({ carouselSlug }) => {
  const { mutate: updateUserCarouselsMutation }
    = useUpdateUserCarouselsMutation()

  const handleDismissCarousel = useCallback(() => {
    updateUserCarouselsMutation({ dismissed: 'true', slug: carouselSlug })
    updateUserCarouselsQueryClient()
  }, [carouselSlug, updateUserCarouselsMutation])

  return (
    <UserCarousel
      carouselSlug={carouselSlug}
      onDismissCarousel={handleDismissCarousel}
    />
  )
}
